import { render } from "./cpt-total-option.vue?vue&type=template&id=70b25099"
import script from "./cpt-total-option.vue?vue&type=script&lang=js"
export * from "./cpt-total-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__